"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubmitHandler = void 0;
var lodash_1 = __importDefault(require("lodash"));
var react_1 = require("react");
/**
 * Transform form data to `{ body }`
 */
var useSubmitHandler = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
mutation, variables) {
    return (0, react_1.useCallback)(function (body) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        mutation({ variables: lodash_1.default.merge(variables, { body: body }) });
    }, [mutation, variables]);
};
exports.useSubmitHandler = useSubmitHandler;
